module.exports = __webpack_public_path__ + "static/img/ppx.17bfdf15.png";